import { useEffect, useState } from "react";
import { setLoading } from "../../store/slices/auth";
import { useDispatch } from "react-redux";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import CreateValidationRule from "./CreateValidationRule";
import { deleteValidationRule, getValidationRules } from "./apiController";
import ModalPopup from "../../widgets/modal";
import ModalComponent from "../common/Modal/modal";
import { validationRulesInfo } from "./utils";


const AddValidationRules = (props) => {
    const { projectData, onClose, forms, groupData, groups } = props;
    const [action, setaction] = useState<any>("");
    const [validationRules, setValidationRules] = useState<any>([]);
    const [selectedRule, setSelectedRule] = useState<any>();
    const dispatch = useDispatch();

    useEffect(() => {
        fetchValidationRules();
    }, []);

    async function fetchValidationRules() {
        dispatch(setLoading(true));
        try {
            const response = await getValidationRules(projectData.TopicID, groupData.id);
            console.log(response)
            setValidationRules(response.data || [])
            // showToaster(toasterTypes.SUCCESS, "Validation Rules Fetched Successfully");
        } catch (error) {
            showToaster(toasterTypes.ERROR, "Failed To Fetch Validation Rules");
            console.log(error)
        } finally {
            dispatch(setLoading(false));
        }
    }

    const handleClose = () => {
        setaction("");
        fetchValidationRules();
    };

    const handleDelete = async () => {
        setaction("")
        const rule = selectedRule;
        dispatch(setLoading(true));
        try {
            const response = await deleteValidationRule(rule.id);
            if (response.success) {
                fetchValidationRules()
                showToaster(toasterTypes.SUCCESS, response.message || "Validation Rule Deleted Successfully");
            }

        } catch (error) {
            showToaster(toasterTypes.ERROR, "Failed To Delete Validation Rule");
            console.log(error)
        } finally {
            dispatch(setLoading(false));
        }
    };

    const onAction = (data, type = "") => {
        switch (type) {
            case "deleteValidationRule":
                {
                    setSelectedRule(data);
                    setaction(type);
                    break;
                }

            case "updateValidationRule":
                {
                    setSelectedRule(data);
                    setaction(type);
                    break;
                }

            default: {
                setaction(type);
                break;
            }
        }
    }

    function getFormName(formId) {
        let temp = forms.find((f) => f.id === formId)
        return temp?.form_name;
    }

    return (
        <>
            {
                (action === "add" || action === "updateValidationRule") &&
                <CreateValidationRule
                    projectData={projectData}
                    previousState={selectedRule}
                    isUpdate={action === "updateValidationRule"}
                    groupData={groupData}
                    groups={groups}
                    forms={forms}
                    onClose={handleClose}
                />
            }
            {
                action === "deleteValidationRule" &&
                <ModalPopup
                    modalType="delete"
                    modalText="Are you sure you want to delete this rule?"
                    closeModal={() => { setaction("") }}
                    onAction={() => { handleDelete() }}
                />
            }
            {
                action === "viewValidationInfo" &&
                <ModalComponent
                    width={"60%"}
                    isOpen={true}
                    onClose={() => setaction("")}
                    header={`Validation Rule Info`}
                    centered={true}
                    customClass='view-validation-rule-info-modal'
                    body={
                        <>
                            <div className="validation-info-body">
                                {validationRulesInfo?.map(rule => (
                                    <div className="validation-item" key={rule.key}>
                                        <h3 className="validation-title">{rule.title}</h3>
                                        <p className="validation-description">{rule.description}</p>
                                    </div>
                                ))}
                            </div>
                        </>
                    }
                    footer={<></>}
                />
            }

            <div className={window.innerWidth < 768 ? "add-validation-rules-container-mobile" : "add-validation-rules-container"}>
                <div className="add-validation-rules-head">
                    <div className="add-validation-rules-head-text">
                        {projectData && projectData.TopicDesc}
                    </div>
                    <div className="add-validation-rules-close-btn">
                        <i className="icon icon-close" onClick={() => onClose()}></i>
                    </div>
                </div>

                <div className="add-validation-rules-content">
                    <div className="add-validation-rules-btn-container">
                        <CustomButton type={"primary"} text={"View Validation Rules Info"} onClick={() => setaction("viewValidationInfo")} />
                        <CustomButton type={"primary"} text={"Add Validation Rule"} onClick={() => setaction("add")} />
                    </div>
                </div>

                <div className="add-validation-rules-list">
                    <h4>Validation Rules List</h4>
                    {validationRules?.length === 0 ? (
                        <p>No validation rules found.</p>
                    ) : (
                        <ul className="validation-rule-items">
                            {validationRules?.map((rule, index) => (
                                <li key={index} className="validation-rule-item">
                                    <div><strong>Validation:</strong> {rule.validation}</div>
                                    <div><strong>Parent Form:</strong> {getFormName(rule.parent_form_id)}</div>
                                    <div><strong>Child Form:</strong> {getFormName(rule.child_form_id)}</div>
                                    <div><strong>Parent Field(s):</strong> {rule.parent_field.join(", ")}</div>
                                    <div><strong>Child Field(s):</strong> {rule.child_field.join(", ")}</div>
                                    {rule?.value && <div><strong>Value:</strong> {rule.value}</div>}
                                    {rule?.allowed_values && <div><strong>Allowed Values:</strong> {rule.allowed_values.join(", ")}</div>}
                                    <div className="validation-rule-actions">
                                        <CustomButton type={"primary"} text={"Update"} onClick={() => onAction(rule, "updateValidationRule")} />
                                        <CustomButton type={"danger"} text={"Delete"} onClick={() => onAction(rule, "deleteValidationRule")} />
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </>
    );
};

export default AddValidationRules;
